module.exports = __webpack_public_path__ + "img/plate.1d4e27ce.png";